import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from '../../../../../../types/types';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../middlewares/segment';
import { setHintCanShow } from '../../../../hints/effects/setHintCanShow';
import { EHintKey } from '../../../../hints';
import { ECloseHintSource } from '../types';
import { hintHide } from '../../../../hints/effects/hintHide';

export function onCloseHint (
    source: ECloseHintSource
): ThunkAction {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        if (source === ECloseHintSource.NOT_NOW) {
            dispatch(segmentTrackAction(SegmentUserEvent.BROWSER_NOTIFICATIONS_NOT_NOW_CLICKED));
            dispatch(hintHide(EHintKey.PUSH_NOTIFICATIONS));
        }
        if (source === ECloseHintSource.CLOSE) {
            dispatch(hintHide(EHintKey.PUSH_NOTIFICATIONS));
        }
    };
    return action
};
